var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progressLinear',{attrs:{"color":("" + (!_vm.education.isActive ? 'grey' : 'light-blue')),"value":_vm.getPercentage(Number(_vm.education.bookElementsApprovedCount), Number(_vm.education.bookElementsMandatoryCount))}}),(!_vm.education.isActive)?_c('p',{staticClass:"ligth-grey",domProps:{"innerHTML":_vm._s(
      _vm.$t('basicEducation.basic-education-period-inactive', {
        proffession: _vm.getProfessionNameById(_vm.education.professionId),
        start: _vm.$options.filters.date(_vm.education.createdAt)
      })
    )}}):_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('basicEducation.basic-education-period-alt2', {
        profession: _vm.getProfessionNameById(_vm.get(_vm.education, 'professionId', null)),
        start: _vm.$options.filters.date(_vm.education.createdAt),
        end: _vm.$options.filters.date(_vm.education.education.calculatedEndDate),
        instructors: _vm.instructorNames,
        companyName: _vm.companyName
      })
    )}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }